import React, { useEffect } from 'react'
import styles from './index.module.css'

const ModalAfterpay = ({ onRequestClose }) => {
  useEffect(() => {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        // Close the modal when the Escape key is pressed
        onRequestClose()
      }
    }

    // Prevent scolling
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', onKeyDown)

    // Clear things up when unmounting this component
    return () => {
      document.body.style.overflow = 'visible'
      document.removeEventListener('keydown', onKeyDown)
    }
  })

  return (
    <div className={styles.modal__backdrop}>
      <div className={styles.modal__container}>
        <div className={styles.modal__body}>
          <img src="/afterpay-info.png" alt="Afterpay" />
          <img
            onClick={onRequestClose}
            className={styles.modal__closeBtn}
            src="/icons/modalCloseBtn.png"
            alt="Close"
          />
        </div>
      </div>
    </div>
  )
}

export default ModalAfterpay
